import { MINIMIZE_CALLING_WIDGET } from 'calling-global-api/constants/EventListeners';
export function triggerHostMessageMinimizeWidget(data) {
  if (window.hsCalling.triggerEvent) {
    window.hsCalling.triggerEvent({
      event: MINIMIZE_CALLING_WIDGET,
      data
    });
  }
}